<!--
	@author bluefirex
-->
<template>
	<div class="zapdos-crm-integration-app">
		<router-view />
	</div>
</template>

<script setup lang="ts">
	import { useColorProps, useColor } from '@Visma-Real-Estate-Solutions/acquisit-ui-vue/helpers'
	import { useDataStore } from '@/stores/data'
	
	const props = defineProps({
		...useColorProps(),
		
	})
	
	const color = useColor(props)
	const dataStore = useDataStore()
</script>

<style lang="scss">
	@use '@/assets/mixins' as m;
	@use '@/assets/reset.css';
	
	* {
		--text: #{m.color("text-dark")};
		--text-secondary: #{m.color("text-secondary-dark")};
		--border-light: #{m.color("border-light")};
		--border: #{m.color("border-light")};
		--background-light: #{m.color("background-light")};
		--box-background-light: #{m.color("box-background-light")};
		--blue: #{m.color("blue")};
		--dark-blue: #{m.color("dark-blue")};
		--red: #{m.color("red")};
		--red-2: #{m.color("red-2")};
		--red-3: #{m.color("red-3")};
		--dark-red: #{m.color("dark-red")};
		--pink: #{m.color("pink")};
		--indigo: #{m.color("indigo")};
		--purple: #{m.color("purple")};
		--purple-2: #{m.color("purple-2")};
		--purple-3: #{m.color("purple-3")};
		--deep-purple: #{m.color("deep-purple")};
		--deep-purple-2: #{m.color("deep-purple-2")};
		--deep-purple-3: #{m.color("deep-purple-3")};
		--cyan: #{m.color("cyan")};
		--teal: #{m.color("teal")};
		--green: #{m.color("green")};
		--green-2: #{m.color("green-2")};
		--green-3: #{m.color("green-3")};
		--light-green: #{m.color("light-green")};
		--light-green-2: #{m.color("light-green-2")};
		--light-green-3: #{m.color("light-green-3")};
		--lime: #{m.color("lime")};
		--yellow: #{m.color("yellow")};
		--amber: #{m.color("amber")};
		--orange: #{m.color("orange")};
		--deep-orange: #{m.color("deep-orange")};
		--brown: #{m.color("brown")};
		--grey: #{m.color("grey")};
		--dark-grey: #{m.color("dark-grey")};
		--light-grey: #{m.color("light-grey")};
		--light-grey-blue: #{m.color("light-grey-blue")};
		--blue-grey: #{m.color("blue-grey")};
		--black: #{m.color("black")};
		--white: #{m.color("white")};
	}
	
	body, html {
		font-size: 11pt;
	}
	
	html {
		min-height: 100%;
	}
	
	body {
		display: flex;
		flex-direction: column;
		min-height: 100svh;
		line-height: 1.5;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		background: #fff;
		
		@include m.main-font();
	}
	
	@media print {
		body, html {
			font-size: 9pt;
		}
	}
	
	.zapdos-crm-integration-app {
		@include m.main-font;
		
		line-height: 1.5;
		min-height: 100svh;
		display: flex;
		flex-direction: column;
	}
</style>
